import { View, Text } from 'tamagui'
import { HeroSelect } from '@components/HeroSelect'
import { QuestionWrapper } from './QuestionWrapper'

interface IAssociationPair {
  id: number
  statement: string
  answer: string
  selectedOption?: string
}

interface IAssociativeQuestionProps {
  pairs: IAssociationPair[]
  onSelect: (id: number, value: string) => void
}

export function AssociativeQuestion({
  pairs,
  onSelect,
}: IAssociativeQuestionProps) {
  return (
    <View gap="$spacing-inset-xs">
      <View gap="$spacing-inset-xs">
        {pairs.map((pair) => (
          <View flexDirection="row" gap="$spacing-inset-xs" key={pair.id}>
            <Text
              alignSelf="center"
              fontFamily="$mulishRegular"
              fontSize="$font-size-sm"
              color="$neutral-800"
              lineHeight={21}
            >
              {pair.id}.
            </Text>
            <View
              borderWidth={1}
              borderColor="$neutral-100"
              flex={1}
              p="$spacing-inset-xs"
              borderRadius="$border-radius-sm"
            >
              <Text
                fontFamily="$mulishRegular"
                fontSize="$font-size-xxs"
                color="$neutral-800"
                lineHeight={21}
              >
                {pair.statement}
              </Text>
            </View>
          </View>
        ))}
      </View>
      <View gap="$spacing-inset-xs" flex={1}>
        {pairs.map((pair) => (
          <QuestionWrapper key={pair.id} isSelected={!!pair.selectedOption}>
            <View
              flexDirection="row"
              py="$spacing-inset-nano"
              gap="$spacing-inset-xs"
              pr="$spacing-inset-xs"
            >
              <View maxWidth={72} alignSelf="center">
                <HeroSelect
                  value={pair.selectedOption}
                  onValueChange={(value) => onSelect(pair.id, value)}
                  placeholder="N"
                  options={Array.from(
                    { length: pairs.length },
                    (_, i) => i + 1,
                  ).map((num) => ({
                    name: num.toString(),
                    value: num.toString(),
                  }))}
                />
              </View>

              <View flex={1}>
                <Text
                  color="$neutral-700"
                  fontSize="$font-size-xxs"
                  fontFamily="$mulishRegular"
                  lineHeight={21}
                >
                  {pair.answer}
                </Text>
              </View>
            </View>
          </QuestionWrapper>
        ))}
      </View>
    </View>
  )
}
